import React from "react";
import cx from "./cx";

/**
 * Progreso. Sin value: barra indeterminada (.rev-progress + relleno completo).
 * Con value/max: <progress> nativo re-vestido, cantidades como ATRIBUTOS.
 * `className` se suma a la clase base (no la sustituye): sirve para re-vestir la
 * pista en un contexto concreto (p. ej. `.rev-rail-card__track` en el raíl oscuro).
 */
const RevProgress = ({ value, max, className, ...rest }) => {
    if (value === undefined) {
        return (
            <div className={cx("rev-progress", className)} {...rest}>
                <div className="rev-progress__fill rev-loading-fill"></div>
            </div>
        );
    }
    return <progress className={cx("rev-progress-native", className)} value={value} max={max} {...rest} />;
};

export default RevProgress;
